import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type ClosedcaptionSolidIconProps = IconProps;

export const ClosedcaptionSolidIcon = forwardRef<
  SVGSVGElement,
  ClosedcaptionSolidIconProps
>(function ClosedcaptionSolidIcon(props: ClosedcaptionSolidIconProps, ref) {
  return (
    <Icon
      data-testid="ClosedcaptionSolidIcon"
      aria-label="closedcaption solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M12 1H0v10h12V1ZM4.306 8c-.37 0-.69-.07-.961-.213a1.433 1.433 0 0 1-.626-.651C2.573 6.843 2.5 6.472 2.5 6.02c0-.47.08-.853.24-1.15.16-.297.382-.517.665-.658A2.17 2.17 0 0 1 4.383 4c.234 0 .444.023.633.07.19.044.352.098.484.163l-.247.655a3.638 3.638 0 0 0-.442-.146c-.15-.04-.296-.06-.435-.06-.228 0-.419.05-.572.15a.9.9 0 0 0-.34.447 2.158 2.158 0 0 0-.109.735 2 2 0 0 0 .113.718.91.91 0 0 0 .336.439.976.976 0 0 0 .548.146c.214 0 .406-.025.576-.077.17-.05.33-.117.48-.198v.71a1.796 1.796 0 0 1-.477.185c-.17.042-.378.063-.625.063Zm3.039-.213c.27.142.59.213.96.213.248 0 .456-.02.626-.063.17-.04.329-.1.477-.184v-.711c-.15.081-.31.147-.48.198-.17.052-.362.077-.576.077a.976.976 0 0 1-.548-.146.91.91 0 0 1-.336-.44 2 2 0 0 1-.113-.717c0-.293.037-.538.11-.735a.9.9 0 0 1 .339-.446c.153-.1.344-.15.572-.15.14 0 .284.02.435.06.15.039.298.087.442.145l.247-.655a2.246 2.246 0 0 0-.484-.163c-.189-.047-.4-.07-.633-.07-.367 0-.693.07-.978.213a1.519 1.519 0 0 0-.665.658c-.16.297-.24.68-.24 1.15 0 .45.073.822.22 1.115.145.293.354.51.625.651Z"
        clipRule="evenodd"
      />
    </Icon>
  );
});
